export const PRECOMPILED_DATASET = {
  rate: 60,
  credit: 3000,
  // DATI DI REDDITO => /dati-reddito
  employmentType: 2,
  employmentSector: 2,
  occupation: 3,
  hiringType: 2,
  monthlyPayment: 3,
  monthlyIncome: "4000",
  employedSince: "02/2015",
  familyMemberCount: 2,
  employedFamilyMemberCount: 2,

  // DATORE DI LAVORO => /dati-lavoro
  employerName: "Team Rocket",
  employerAddress: "via Vai",
  employerStreetNumber: "123",
  employerPostalCode: "20146",
  employerCity: "MILANO (MI)",
  employerPhone: "+39 3331234567",

  // DATI DI ANAGRAFICA E ABITAZIONE => /anagrafica-abitazione
  maritalStatus: 3,
  housingType: 5,
  residenceSince: "05/2010",
  politicallyExposedPerson: false,
};
